









import {
  Component,
  Prop,
  Vue
} from "@/shared/vuepack";
import {
  HsabAccountNametag,
  InvestmentCustodian
} from "@/shared/types";
import { formatCurrency } from "@/shared/currency.js";
import BalanceAmount from "@/employee/components/landing-pages/accountSummaryDashboard/BalanceAmount.vue";
import { useInvestmentDailyBalanceStore } from "@/shared/store/investmentDailyBalance";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useHsabInvestmentStore } from "@/shared/store/hsabInvestment";

@Component({
  components: {
    BalanceAmount
  }
})
export default class HsaAccountCardBody extends Vue {
  formatCurrency = formatCurrency;

  investmentDailyBalanceStore = useInvestmentDailyBalanceStore();
  drivewealthStore = useDrivewealthStore();
  custodianSettingsStore = useCustodianSettingsStore();
  hsabInvestmentsStore = useHsabInvestmentStore();

  @Prop({ required: true })
  account: HsabAccountNametag;

  mounted (): void {
    this.loadBalance();
  }

  loadBalance () {
    this.investmentDailyBalanceStore.loadCurrentDailyBalance();
    this.loadDrivewealthIfNeeded();
  }

  loadDrivewealthIfNeeded () {
    if (this.custodianSettingsStore.investmentCustodian === InvestmentCustodian.Drivewealth) {
      this.drivewealthStore.loadAccountSummary();
    }
  }

  get displayInvestments (): boolean {
    if (this.custodianSettingsStore.investmentCustodian === InvestmentCustodian.HsaBank) {
      return this.hsabInvestmentsStore.hsabInvestmentsEnabled;
    }

    return this.custodianSettingsStore.displayInvestmentsSection;
  }
}
